module.exports = __webpack_public_path__ + "img/accessory_shirt_03.a0853305.svg";